import { useState } from "react";
import { Link } from "react-router-dom";
import { Home, Mail, Loader2, CheckCircle2, ArrowLeft } from "lucide-react";
import apiClient, { formatApiErrorDetail } from "@/lib/api";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await apiClient.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16" data-testid="forgot-password-page">
      <div className="text-center mb-8">
        <span className="inline-grid place-items-center w-12 h-12 rounded-2xl bg-primary text-primary-foreground mb-4">
          <Home size={22} />
        </span>
        <h1 className="font-heading text-3xl font-bold tracking-tight">Lupa Password</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Masukkan email akun Anda. Kami akan mengirim tautan untuk mengatur ulang password.
        </p>
      </div>

      {sent ? (
        <div className="bg-card border border-border rounded-2xl p-6 text-center space-y-3" data-testid="forgot-password-success">
          <CheckCircle2 size={40} className="mx-auto text-emerald-600" />
          <p className="text-sm text-foreground">
            Jika email <span className="font-semibold">{email}</span> terdaftar, kami telah mengirim tautan reset password.
            Silakan cek kotak masuk (dan folder spam) Anda. Tautan berlaku 60 menit.
          </p>
          <Link to="/login" className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary hover:underline" data-testid="forgot-back-to-login">
            <ArrowLeft size={15} /> Kembali ke Login
          </Link>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="bg-card border border-border rounded-2xl p-6 space-y-4">
          {error && (
            <div className="rounded-xl bg-destructive/10 border border-destructive/30 px-4 py-3 text-sm text-destructive" data-testid="forgot-password-error">
              {error}
            </div>
          )}
          <div>
            <label className="text-sm font-medium text-foreground">Email</label>
            <div className="mt-1.5 flex items-center gap-2 rounded-xl bg-secondary/50 px-3 focus-within:ring-2 focus-within:ring-primary focus-within:bg-background transition-colors">
              <Mail size={16} className="text-muted-foreground" />
              <input
                type="email"
                required
                data-testid="forgot-email-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="nama@email.com"
                className="flex-1 bg-transparent outline-none text-sm py-3"
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="forgot-submit-button"
            className="w-full py-3 rounded-full bg-accent text-accent-foreground font-semibold hover:scale-[1.02] active:scale-95 transition-transform disabled:opacity-60 disabled:hover:scale-100 flex items-center justify-center gap-2"
          >
            {loading && <Loader2 size={16} className="animate-spin" />}
            {loading ? "Mengirim..." : "Kirim Tautan Reset"}
          </button>
          <p className="text-center text-sm text-muted-foreground">
            <Link to="/login" className="inline-flex items-center gap-1.5 font-semibold text-primary hover:underline" data-testid="forgot-to-login-link">
              <ArrowLeft size={14} /> Kembali ke Login
            </Link>
          </p>
        </form>
      )}
    </div>
  );
}
